import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import UserProfile from "./components/UserProfile";
import "./app.css";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/:slug" element={<UserProfile />} />
        {/* Add other routes here */}
        <Route path="*" element={<div>Page not found</div>} />
      </Routes>
    </Router>
  );
};

export default App;
